import { useEffect } from 'react'

import useGetAccount from 'hooks/data/useGetAccount'
import { useAccountSenderIds } from 'hooks/data/useAccountSenderIds'
import useOrganization from 'hooks/data/useOrganization'
import type { GenericDetailsStateMachine } from 'types/api/common'
import type { UserProfileResponseType } from 'types/api/responses/profiles'
import type { credentials } from 'types/auth'
import {
	buildChatSasaUserData,
	CHAT_SASA_MAX_SENDER_IDS,
	clearChatSasaUserDataWhenReady,
} from 'utils/chatsasaUserContext'

export default function ChatSasaUserContextBridge({
	credentials,
	profileState,
}: {
	credentials: credentials
	profileState: GenericDetailsStateMachine<UserProfileResponseType>
}) {
	const { data: accountData } = useGetAccount({ accountId: credentials.accountId })
	const { data: organizationData } = useOrganization()
	const { data: senderIDsData } = useAccountSenderIds({
		accountId: credentials.accountId,
		params: { page: 1, per: CHAT_SASA_MAX_SENDER_IDS },
	})

	useEffect(() => clearChatSasaUserDataWhenReady(), [credentials.accountId.value])

	useEffect(() => {
		if (profileState.status !== 'resolved') return undefined

		const setChatSasaUserData = () => {
			window.ChatSasa?.setUserData(
				buildChatSasaUserData({
					profile: profileState.data,
					account: accountData?.data,
					organization: organizationData?.data,
					senderIDs: senderIDsData?.data?.sender_ids,
				}),
			)
		}

		setChatSasaUserData()
		window.addEventListener('chatsasa:ready', setChatSasaUserData)
		return () => window.removeEventListener('chatsasa:ready', setChatSasaUserData)
	}, [accountData, organizationData, profileState, senderIDsData])

	return null
}
